import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import SecondaryTitle from 'components/title_secondary/title_secondary'
import { TextInput } from 'components/dpc_input'
import CheckboxInput from 'components/checkbox/checkbox'
import TextLink from 'components/text_link/text_link'
import NearpodPickerBottomBar from '../../components/bottom_bar/nearpod_picker_bottom_bar'
import { normalizeWebContent } from 'helpers/pickerNormalizer'
import { localize } from 'helpers/translator'

import styles from './nearpod_picker_web.scss'

class NearpodPickerWeb extends PureComponent {

	constructor() {
		super()
		this.save = this.save.bind(this)
		this.handleOnChange = this.handleOnChange.bind(this)
		this.handleOnBlur = this.handleOnBlur.bind(this)
		this.handleOnEnterKey = this.handleOnEnterKey.bind(this)
		this.getLink = this.getLink.bind(this)
		this.state = {
			webpage: '',
			error: '',
			status: '',
		}
	}

	handleOnChange(event) {
		this.setState({webpage: event.target.value, error: '', status: ''})
	}

	handleOnBlur() {
		if (this.state.webpage) {
			if (!/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/g.test(this.state.webpage)) {
				this.setState({error: localize('picker_webpage_error_invalid_url'), status: 'error'})
			} else {
				this.setState({error: '', status: ''})
			}
		} else {
			this.setState({error: localize('picker_webpage_error_invalid_website'), status: 'error'})
		}
	}

	handleOnEnterKey() {
		this.save()
	}

	save() {
		if (!this.state.error) {
			this.props.onFilesPicked(normalizeWebContent(this.state.webpage))
		}
	}

	getLink() {
		if (this.state.webpage.toLowerCase().includes('https://') || this.state.webpage.toLowerCase().includes('http://')) {
			return this.state.webpage
		} else {
			return `http://${this.state.webpage}`
		}
	}

	render() {
		return (
			<div styleName='wrapper'>
				<SecondaryTitle isCentered={true}>{localize('picker_webpage_title')}</SecondaryTitle>
				<div styleName='web-content'>
					<p styleName='web-content-title'>{localize('picker_webpage_subtitle')}</p>
					<div styleName='web-content-input'>
						<TextInput
							type='text'
							icons={{active: true}}
							message={this.state.error}
							placeholder='URL'
							onChange={this.handleOnChange}
							onBlur={this.handleOnBlur}
							status={this.state.status}
							onEnterKey={this.handleOnEnterKey}
						/>
					</div>
					<div styleName='web-content-test-link'>
						{ this.state.webpage &&
							<TextLink href={this.getLink()} target="_blank" >{localize('picker_webpage_test_link')}</TextLink>
						}
					</div>
					<div styleName='web-content-option' style={{display: 'none'}}>
						<CheckboxInput id='' />
						<label styleName='web-content-option-label'>{localize('picker_webpage_add_anyway')}</label>
					</div>
					<p styleName='web-content-note'>
						{localize('picker_webpage_note_part1')}<br />
						{localize('picker_webpage_note_part2')}
					</p>
				</div>
				<NearpodPickerBottomBar cancelHandler={this.props.closeHandler} saveHandler={this.save} saveButtonEnabled={this.state.webpage} />
			</div>
		)
	}
}

export default CSSModules(NearpodPickerWeb, styles, {allowMultiple: true})
